import clx from '../util/clx'
import React, { FunctionComponent } from 'react'

type BoxProps = React.HTMLAttributes<HTMLDivElement>

const Box: FunctionComponent<BoxProps> = ({ children, ...props }) => {
	const { className, ...otherProps } = props
	const cl = clx('box', className)

	return (
		<div className={cl} {...otherProps}>
			{children}
		</div>
	)
}

export default Box
